$(document).ready(()=>{
    function updateVariantUrl (variantId) {
        if (!history.replaceState || !variantId) {
            return;
        }
        var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variantId;
        window.history.replaceState({path: newurl}, '', newurl);
    }
    function updateVariantSpecs (variantId) {
        $('.js-variant-specs').not(`[data-variant-id="${variantId}"]`).addClass('hide');
        $('.js-variant-specs').filter(`[data-variant-id="${variantId}"]`).removeClass('hide');
    }
    $('.Product_info_header').click(function (e) {
        const field = $(this).attr('data-field')
        const parrentBlock = $('#'+field)
        if(parrentBlock.attr('data-show') === "true"){
            parrentBlock.attr('data-show',false)
        }else{
            parrentBlock.attr('data-show',true)
        }
    })
    $('.Product_info_license_select').click(function () {
        if($(this).hasClass('disabled')){
            return;
        }
        const isSelected = $(this).attr('data-selected')
        const productId = $(this).attr('data-product-id')
        const productPrice = $(this).attr('data-product-price')

        if (isSelected !== "true"){
            $('.Product_info_license_select').attr('data-selected',false)
            $(this).attr('data-selected',true)
            $('#product-value').val(productId)
            $('p.product-price').html(`<span data-money-val="${productPrice}" class="money">${productPrice}</span>`)
            let iso = localStorage.getItem('selectedCurrency')
            convertPrices(iso)
            // updateVariantUrl(productId)
            updateVariantSpecs(productId)
        }
    })

function updatePrice() {


  var isSelected = $("#product_info_license_select").attr('data-selected')
        var productId = $("#product_info_license_select").attr('data-product-id')
        var productPrice = $("#product_info_license_select").attr('data-product-price')
  if (isSelected == "true"){
            $('.Product_info_license_select').attr('data-selected',false)
            $("#product_info_license_select").attr('data-selected',true)
            $('#product-value').val(productId)
            $('p.product-price').html(`<span data-money-val="${productPrice}" class="money">${productPrice}</span>`)
            let iso = localStorage.getItem('selectedCurrency')
            convertPrices(iso)
            // updateVariantUrl(productId)
            updateVariantSpecs(productId)
        }
}

  setInterval(function () {

    var only_licens_select=parseInt($("#only_licens_select").val());
    if(only_licens_select==1)
    {
      updatePrice();
    }
  }, 500);
  
 // updatePrice();
  
 // $('.Product_info_license_select').click();
  

    $('.Container .arrow-back').attr('href',document.referrer)

    $('#product-buy-form .Button').click((e)=>{
        e.preventDefault();
        /*fetch('/cart/change.js', {
            body: JSON.stringify({ id: e.attr('data-line-id'), quantity: 1 }),
            credentials: 'same-origin',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
            }
        }).then(function (cart) {
            cart.json().then(function (content) {
                _this29.itemCount = content['item_count'];
                _this29._rerenderCart(elementToAnimate);

                document.dispatchEvent(new CustomEvent('theme:loading:end'));
            });
        });*/
        $.ajax({
            url:'/cart/add',
            type:"post",
            data:$('#product-buy-form').serialize(),
            success:(d)=>{
                //CartSection._replaceContent()
                //document.body.innerHTML = d;
                $('.QuantitySelector__CurrentQuantity input').trigger('change');
                  window.location.href = "/cart";
            }
        })
    })

    

})

